/**
 * AnalyticsFilterBar — date + org multi-select used by Loans, Deposits.
 *
 * Owns no state. Parent passes current filter values + change handlers; the
 * filter values typically live in URL search params so back/forward navigation
 * restores the view.
 */

import React from 'react';

import DatePicker from './DatePicker';
import OrgMultiSelect from './OrgMultiSelect';
import type { Bank } from '../type/api';

interface Props {
	date: string | null;
	availableDates?: string[];
	onDateChange: (next: string) => void;

	banks: Bank[];
	selectedOrgIds: number[];
	onOrgIdsChange: (ids: number[]) => void;

	onRefresh?: () => void;
	loading?: boolean;
}

export default function AnalyticsFilterBar({
	date,
	availableDates,
	onDateChange,
	banks,
	selectedOrgIds,
	onOrgIdsChange,
	onRefresh,
	loading = false,
}: Props) {
	const banksLabel =
		selectedOrgIds.length === 0
			? '— filtered to all 125 banks'
			: selectedOrgIds.length === 1
			? '— scoped to 1 bank · branch breakdown shown below'
			: `— scoped to ${selectedOrgIds.length} banks · branch breakdown shown below`;

	return (
		<div className="filterbar">
			<DatePicker
				value={date}
				availableDates={availableDates}
				onChange={onDateChange}
				label="Snapshot"
			/>

			<OrgMultiSelect
				banks={banks}
				selected={selectedOrgIds}
				onChange={onOrgIdsChange}
				placeholder="All banks"
			/>

			<span style={{ fontSize: 11, color: 'var(--text-faint)', marginLeft: 4 }}>
				{banksLabel}
			</span>

			{onRefresh && (
				<button
					type="button"
					className="btn ghost"
					onClick={onRefresh}
					disabled={loading}
					style={{ marginLeft: 'auto' }}
				>
					Refresh
				</button>
			)}
		</div>
	);
}
